import axios from 'components/Axios';
import { manageMention } from '../APIEndPoint';

const getManageMention = () => {
  const promise = axios.get(manageMention);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const updateManageMention = (payload) => {
  const promise = axios.put(manageMention, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const submitReportReason = (payload) => {
  const promise = axios.post('/reports', payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
}

export {
  getManageMention,
  updateManageMention,
  submitReportReason
};
